import angular from 'angular';

import CessionsConfig from './_config/cessions.config';
import CessionsRoutes from './_config/cessions.routes';
import CessionsComponent from './components';
import CessionsService from './services/cessions.service';

const moduleName = 'app.massia.gestion.cessions';

angular
	.module(moduleName, [])
	.config(CessionsConfig)
	.config(CessionsRoutes)
	.service('CessionsService', CessionsService)
	.component('cessions', CessionsComponent);

export default moduleName;
